// B1-INT - Ünite 2: Deneyim ve Motivasyon Soruları
// B1 seviyesinde basit İngilizce ile gerçekçi mülakat senaryoları

export const B1INT_UNIT_2 = {
  'B1INT-U2-L1': {
    id: 'B1INT-U2-L1',
    title: 'Describe your customer service experience',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Mülakatçı bilmek istiyor:\n\n• Daha önce müşteriyle çalıştın mı?\n• Nasıl bir deneyimin var?\n• Örnekler verebiliyor musun?\n• Hizmet anlayışın ne?'
        },
        {
          type: 'info',
          title: '💼 Müşteri Hizmeti Deneyimi Örnekleri',
          content: '• Hotel receptionist (otel resepsiyonisti)\n• Restaurant waiter/waitress (garson)\n• Shop assistant (mağaza görevlisi)\n• Call center agent (çağrı merkezi temsilcisi)\n• Tour guide (tur rehberi)\n• Airport ground staff (havalimanı yer personeli)'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Deneyim Anlatma',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Can you tell me about your customer service experience?',
              translation: 'Müşteri hizmeti deneyiminizden bahseder misiniz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Yes! I worked as a waiter at a restaurant for two years. We had both Turkish and foreign guests.',
              translation: 'Evet! İki yıl bir restoranda garson olarak çalıştım. Hem Türk hem yabancı misafirlerimiz vardı.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'My job was to take orders, serve food, and make sure guests were happy. I learned to smile even when I was tired!',
              translation: 'İşim sipariş almak, yemek servisi yapmak ve misafirlerin mutlu olduğundan emin olmaktı. Yorgun olduğumda bile gülümsemeyi öğrendim!'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also helped with complaints. Once, a guest\'s food was cold. I apologized, brought hot food quickly, and gave a free dessert. The guest left happy.',
              translation: 'Şikayetlerle de ilgilendim. Bir kez bir misafirin yemeği soğuktu. Özür diledim, hızlıca sıcak yemek getirdim ve ücretsiz tatlı verdim. Misafir mutlu ayrıldı.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ Net iş tanımı (waiter, 2 years)\n✅ Görevleri açıkladı (orders, serve, complaints)\n✅ Somut örnek verdi (cold food → solution)\n✅ Sonucu söyledi (guest left happy)'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Can you tell me about your customer service experience?',
              translation: 'Müşteri hizmeti deneyiminizden bahseder misiniz?'
            },
            {
              speaker: 'Kötü Cevap',
              text: 'I worked at a restaurant. It was okay. I served food and things like that.',
              translation: 'Bir restoranda çalıştım. İyiydi. Yemek servisi yaptım ve bunun gibi şeyler.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '❌ Çok kısa ve belirsiz\n❌ "It was okay" = ilgisiz görünüyor\n❌ "Things like that" = profesyonel değil\n❌ Örnek veya detay yok'
        },
        {
          type: 'tip',
          content: '💡 KURAL: Deneyim = İş + Süre + Görevler + Örnek + Sonuç'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Deneyim anlatırken hangisi ÖNEMLİ?',
          options: [
            'Sadece iş adını söylemek',
            'İş + süre + görevler + somut örnek',
            'Ne kadar para kazandığını söylemek',
            'Patronunu övmek'
          ],
          correctIndex: 1,
          explanation: 'Tam deneyim = İş adı, süre, görevler ve somut örnek içerir.'
        }
      ]
    }
  },

  'B1INT-U2-L2': {
    id: 'B1INT-U2-L2',
    title: 'How do you handle difficult customers?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Kabin memurluğunda ZOR yolcular olacak:\n\n• Öfkeli yolcular\n• Sabırsız yolcular\n• Sarhoş yolcular\n• Şikayet eden yolcular\n\nNasıl tepki verirsin?'
        },
        {
          type: 'framework',
          title: '📋 4 Adım: L-A-S-T',
          content: '**L - Listen (Dinle)**\nÖnce tamamen dinle, sözünü kesme\n\n**A - Apologize (Özür dile)**\n"I\'m sorry you feel this way"\n\n**S - Solve (Çöz)**\nNe yapabileceğini bul ve yap\n\n**T - Thank (Teşekkür et)**\n"Thank you for your patience"'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Zor Müşteri',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'How do you handle a difficult customer? Can you give me an example?',
              translation: 'Zor bir müşteriyle nasıl başa çıkarsınız? Örnek verebilir misiniz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Yes, I can share an example from the hotel. One night, a guest came to reception very angry. His room was not ready.',
              translation: 'Evet, otelden bir örnek paylaşabilirim. Bir gece bir misafir resepsiyona çok kızgın geldi. Odası hazır değildi.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I listened to him. I didn\'t interrupt. Then I said: "I\'m really sorry, sir. I understand this is frustrating."',
              translation: 'Önce onu dinledim. Sözünü kesmedim. Sonra dedim: "Gerçekten özür dilerim efendim. Bunun sinir bozucu olduğunu anlıyorum."'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Then I found a solution. I said: "Please wait in our lounge. I\'ll bring you free coffee, and your room will be ready in 15 minutes."',
              translation: 'Sonra bir çözüm buldum. Dedim: "Lütfen lounge\'da bekleyin. Size ücretsiz kahve getireceğim ve odanız 15 dakika içinde hazır olacak."'
            },
            {
              speaker: 'Aday (devam)',
              text: 'After 15 minutes, I personally took him to his room and gave a small gift. He smiled and said thank you. Next day, he said I was "very professional."',
              translation: '15 dakika sonra onu şahsen odasına götürdüm ve küçük bir hediye verdim. Gülümsedi ve teşekkür etti. Ertesi gün "çok profesyonel" olduğumu söyledi.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ LAST metodunu kullandı:\n• Listen: "I listened to him"\n• Apologize: "I\'m really sorry"\n• Solve: "coffee + room in 15 min"\n• Thank: Misafir teşekkür etti\n\n✅ Somut örnek + sonuç'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevaplar',
          dialogues: [
            {
              speaker: 'Kötü Cevap 1',
              text: 'I always stay calm. I never get angry.',
              translation: 'Her zaman sakin kalırım. Asla sinirlenmem.'
            },
            {
              speaker: 'Kötü Cevap 2',
              text: 'If a customer is rude, I call my manager.',
              translation: 'Bir müşteri kabalık yaparsa müdürümü çağırırım.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '**Cevap 1:** Örnek yok, sadece genel ifade\n**Cevap 2:** Sorunu kendin çözmiyorsun, başkasına atıyorsun'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'LAST metodunda "A" ne demek?',
          options: [
            'Ask questions (Soru sor)',
            'Apologize (Özür dile)',
            'Agree with customer (Müşteriyle hemfikir ol)',
            'Argue back (Karşılık ver)'
          ],
          correctIndex: 1,
          explanation: 'A = Apologize. Müşteri haklı olmasa bile, "I\'m sorry you feel this way" de.'
        }
      ]
    }
  },

  'B1INT-U2-L3': {
    id: 'B1INT-U2-L3',
    title: 'What do you know about our company?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Mülakatçı test ediyor:\n\n• Araştırma yaptın mı?\n• Gerçekten bu şirketi mi istiyorsun?\n• Detayları biliyor musun?'
        },
        {
          type: 'info',
          title: '📚 Turkish Airlines - Temel Bilgiler',
          content: '• **Kuruluş:** 1933\n• **Hub:** İstanbul Havalimanı\n• **Destinasyon:** 340+ şehir, 129 ülke\n• **Slogan:** "Widen Your World"\n• **İttifak:** Star Alliance\n• **Özellik:** En fazla ülkeye uçan havayolu\n• **Değer:** Türk misafirperverliği'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Şirket Bilgisi',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What do you know about Turkish Airlines?',
              translation: 'Türk Hava Yolları hakkında ne biliyorsunuz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'I know that Turkish Airlines was founded in 1933. It\'s one of the oldest airlines in the world!',
              translation: 'Türk Hava Yolları\'nın 1933\'te kurulduğunu biliyorum. Dünyanın en eski havayollarından biri!'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Today, THY flies to more than 120 countries. That\'s more than any other airline. The main hub is Istanbul Airport.',
              translation: 'Bugün THY 120\'den fazla ülkeye uçuyor. Bu diğer tüm havayollarından fazla. Ana merkez İstanbul Havalimanı.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'THY is also part of Star Alliance. And I love the slogan "Widen Your World" - it shows the airline connects people everywhere.',
              translation: 'THY ayrıca Star Alliance\'ın parçası. Ve "Widen Your World" sloganını seviyorum - havayolunun her yerde insanları birleştirdiğini gösteriyor.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Most importantly, THY is famous for Turkish hospitality. Passengers feel like guests, not just customers.',
              translation: 'En önemlisi, THY Türk misafirperverliğiyle ünlü. Yolcular sadece müşteri değil, misafir gibi hissediyor.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ Tarih bilgisi (1933)\n✅ Sayılar (120+ ülke)\n✅ Hub bilgisi (İstanbul)\n✅ İttifak (Star Alliance)\n✅ Slogan ve değer'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What do you know about Turkish Airlines?',
              translation: 'Türk Hava Yolları hakkında ne biliyorsunuz?'
            },
            {
              speaker: 'Kötü Cevap',
              text: 'It\'s a Turkish airline. It\'s big. I think you fly to many places.',
              translation: 'Türk havayolu. Büyük. Sanırım birçok yere uçuyorsunuz.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '❌ "I think" = Bilmiyorsun, tahmin ediyorsun\n❌ Hiç detay yok\n❌ Araştırma yapmadığı belli'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'THY kaç ülkeye uçuyor?',
          options: [
            '50 ülke',
            '80 ülke',
            '120+ ülke',
            '200 ülke'
          ],
          correctIndex: 2,
          explanation: 'THY 129 ülkeye uçuyor - dünyada en fazla ülkeye uçan havayolu!'
        }
      ]
    }
  },

  'B1INT-U2-L4': {
    id: 'B1INT-U2-L4',
    title: 'Where do you see yourself in 5 years?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Mülakatçı bilmek istiyor:\n\n• Uzun süre kalacak mısın?\n• Kariyer hedeflerin ne?\n• Şirkette büyümek istiyor musun?\n• Gerçekçi misin?'
        },
        {
          type: 'info',
          title: '✅ İyi Hedefler',
          content: '• "I want to become a senior cabin crew"\n• "I hope to be a purser one day"\n• "I want to train new crew members"\n• "I want to grow with this company"'
        },
        {
          type: 'warning',
          title: '❌ Kötü Hedefler',
          content: '• "I want to be a pilot" ❌ (farklı kariyer)\n• "I want to start my own business" ❌ (ayrılacak)\n• "I don\'t know" ❌ (hedefsiz)\n• "I want to work for another airline" ❌ (sadakat yok)'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: 5 Yıl Sonra',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Where do you see yourself in 5 years?',
              translation: '5 yıl sonra kendinizi nerede görüyorsunuz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'In 5 years, I hope to be a senior cabin crew member at Turkish Airlines.',
              translation: '5 yıl içinde Türk Hava Yolları\'nda kıdemli kabin memuru olmayı umuyorum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'First, I want to learn everything about the job. I want to fly to different destinations and gain experience.',
              translation: 'Önce iş hakkında her şeyi öğrenmek istiyorum. Farklı destinasyonlara uçmak ve deneyim kazanmak istiyorum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'After a few years, I would like to help train new crew members. Maybe one day, I can become a purser.',
              translation: 'Birkaç yıl sonra yeni ekip üyelerini eğitmeye yardım etmek isterim. Belki bir gün kabin amiri olabilirim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'My goal is to build a long career with THY. I\'m not looking for a short-term job.',
              translation: 'Hedefim THY ile uzun bir kariyer inşa etmek. Kısa vadeli bir iş aramıyorum.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden İyi?',
          content: '✅ Şirkette büyüme hedefi\n✅ Gerçekçi adımlar (learn → senior → purser)\n✅ "Long career" = bağlılık gösteriyor\n✅ "Not short-term" = güven veriyor'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevaplar',
          dialogues: [
            {
              speaker: 'Kötü Cevap 1',
              text: 'I want to become a pilot in 5 years.',
              translation: '5 yıl içinde pilot olmak istiyorum.'
            },
            {
              speaker: 'Kötü Cevap 2',
              text: 'I don\'t know. I\'ll see what happens.',
              translation: 'Bilmiyorum. Ne olacağını göreceğim.'
            },
            {
              speaker: 'Kötü Cevap 3',
              text: 'I want to work for Emirates or Qatar Airways.',
              translation: 'Emirates veya Qatar Airways için çalışmak istiyorum.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '**Cevap 1:** Pilot farklı kariyer - eğitim seni vermeyi neden?\n**Cevap 2:** Hedefsiz görünüyorsun\n**Cevap 3:** Rakip şirket adı = sadakat yok'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"5 yıl sonra" sorusunda EN İYİ cevap:',
          options: [
            'I want to be a pilot.',
            'I want to grow as a senior crew and maybe become purser.',
            'I don\'t know yet.',
            'I want to work for Emirates.'
          ],
          correctIndex: 1,
          explanation: 'Şirket içinde büyüme hedefi = bağlılık ve motivasyon gösterir.'
        }
      ]
    }
  },

  'B1INT-U2-L5': {
    id: 'B1INT-U2-L5',
    title: 'Pratik: Deneyim Anlatma',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Ünite 2 Pratiği',
          content: 'Şimdi Ünite 2\'de öğrendiklerini tam bir mülakatta göreceksin!'
        },
        {
          type: 'scenario',
          title: '✈️ TAM MÜLAKAT: Deneyim Soruları',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Let\'s talk about your experience. Can you describe your customer service experience?',
              translation: 'Deneyiminiz hakkında konuşalım. Müşteri hizmeti deneyiminizi anlatır mısınız?'
            },
            {
              speaker: 'Aday',
              text: 'Of course! I worked at a coffee shop for one year after university. I was a barista.',
              translation: 'Tabii! Üniversiteden sonra bir kahve dükkanında bir yıl çalıştım. Baristaydım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Every day, I served about 100 customers. I made drinks, took orders, and sometimes helped with complaints.',
              translation: 'Her gün yaklaşık 100 müşteriye hizmet verdim. İçecek yaptım, sipariş aldım ve bazen şikayetlerle ilgilendim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I learned that a smile and good attitude can make any customer happy - even on a Monday morning!',
              translation: 'Bir gülümseme ve iyi bir tutumun herhangi bir müşteriyi mutlu edebileceğini öğrendim - Pazartesi sabahı bile!'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Good! How do you handle difficult customers?',
              translation: 'İyi! Zor müşterilerle nasıl başa çıkarsınız?'
            },
            {
              speaker: 'Aday',
              text: 'I remember one customer who was very angry. His coffee was wrong. He said: "This is not what I ordered!"',
              translation: 'Çok kızgın bir müşteriyi hatırlıyorum. Kahvesi yanlıştı. Dedi: "Sipariş ettiğim bu değil!"'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I listened first, then said: "I\'m very sorry, sir. Let me make a new one right now." I made his drink again.',
              translation: 'Önce dinledim, sonra dedim: "Çok özür dilerim efendim. Hemen yeni bir tane yapayım." İçeceğini tekrar yaptım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also gave him a free cookie and said: "Thank you for telling me." He smiled and became a regular customer!',
              translation: 'Ayrıca ona ücretsiz bir kurabiye verdim ve dedim: "Söylediğiniz için teşekkür ederim." Gülümsedi ve düzenli müşteri oldu!'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Very nice! What do you know about Turkish Airlines?',
              translation: 'Çok güzel! Türk Hava Yolları hakkında ne biliyorsunuz?'
            },
            {
              speaker: 'Aday',
              text: 'Turkish Airlines is one of the world\'s best airlines. It was founded in 1933 and now flies to over 120 countries.',
              translation: 'Türk Hava Yolları dünyanın en iyi havayollarından biri. 1933\'te kuruldu ve şimdi 120\'den fazla ülkeye uçuyor.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'The hub is Istanbul Airport. THY is part of Star Alliance. I love the slogan "Widen Your World."',
              translation: 'Merkez İstanbul Havalimanı. THY Star Alliance\'ın parçası. "Widen Your World" sloganını seviyorum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Most importantly, THY is famous for Turkish hospitality. I want to be part of that tradition!',
              translation: 'En önemlisi, THY Türk misafirperverliğiyle ünlü. Bu geleneğin bir parçası olmak istiyorum!'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Last question: Where do you see yourself in 5 years?',
              translation: 'Son soru: 5 yıl sonra kendinizi nerede görüyorsunuz?'
            },
            {
              speaker: 'Aday',
              text: 'In 5 years, I want to be a senior cabin crew at THY. First, I will learn everything about the job and become very good at service.',
              translation: '5 yıl içinde THY\'de kıdemli kabin memuru olmak istiyorum. Önce iş hakkında her şeyi öğreneceğim ve serviste çok iyi olacağım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Then, I hope to help train new crew members. Maybe one day I can become a purser. I want a long career with THY!',
              translation: 'Sonra yeni ekip üyelerini eğitmeye yardım etmeyi umuyorum. Belki bir gün kabin amiri olabilirim. THY ile uzun bir kariyer istiyorum!'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Great answers! Thank you.',
              translation: 'Harika cevaplar! Teşekkürler.'
            }
          ]
        },
        {
          type: 'summary',
          title: '📊 Mülakat Analizi',
          content: '**✅ Aday şunları iyi yaptı:**\n• Her soru için ÖRNEK verdi\n• LAST metodunu kullandı (Listen-Apologize-Solve-Thank)\n• Şirket araştırması yaptığı belli (tarih, sayılar, slogan)\n• Kariyer hedefi şirket içinde (loyalty)\n• B1 seviyesinde basit ama etkili İngilizce'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Bu mülakatta aday hangi metodu kullandı?',
          options: [
            'STAR metodu',
            'LAST metodu (Listen-Apologize-Solve-Thank)',
            'ABC metodu',
            'Hiçbir metod'
          ],
          correctIndex: 1,
          explanation: 'Zor müşteri sorusunda LAST metodunu uyguladı: Dinle → Özür dile → Çöz → Teşekkür et'
        }
      ]
    }
  },

  'B1INT-U2-EXAM': {
    id: 'B1INT-U2-EXAM',
    title: 'Unit 2 Exam: Describing Experience',
    type: 'exam',
    content: {
      timeLimit: 20,
      passingScore: 70,
      questions: [
        {
          type: 'multipleChoice',
          question: 'When describing your work experience, what should you include?',
          options: [
            'Only the job title',
            'Job title, duration, responsibilities, and specific examples',
            'Salary and working hours',
            'Your manager\'s name'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In the LAST method for handling complaints, what does "L" stand for?',
          options: [
            'Look',
            'Listen',
            'Leave',
            'Laugh'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'When was Turkish Airlines founded?',
          options: [
            '1923',
            '1933',
            '1953',
            '1983'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is the WORST answer to "Where do you see yourself in 5 years?"',
          options: [
            'I want to be a senior cabin crew member with your airline.',
            'I want to work for Emirates or another competitor.',
            'I hope to become a purser and lead a team.',
            'I want to train new crew members and share my experience.'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Why is giving a specific example important when answering difficult customer questions?',
          options: [
            'To make your answer longer',
            'It proves you have real experience handling such situations',
            'To entertain the interviewer',
            'It is not important'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'How should you answer "Tell me about a time you dealt with a difficult customer"?',
          options: [
            'Say you never had difficult customers',
            'Describe the situation, your actions, and the positive result',
            'Blame the customer for being rude',
            'Say you called your manager every time'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which phrase is best to start describing a past experience?',
          options: [
            'Maybe I think...',
            'In my previous role at...',
            'I don\'t remember but...',
            'My friend told me...'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default B1INT_UNIT_2;
